/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_item = {
    readonly popularSearchesLink: {
        readonly " $fragmentRefs": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
    };
    readonly " $refType": "SharedRespLinksBlock_item";
};
export type SharedRespLinksBlock_item$data = SharedRespLinksBlock_item;
export type SharedRespLinksBlock_item$key = {
    readonly " $data"?: SharedRespLinksBlock_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedRespLinksBlock_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "popularSearchesLink",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '3df590818322d1a95955cbda2b44bf7a';
export default node;
